import {useRouter} from 'next/router'
import {useMemo, useState, createContext, useContext} from 'react'

import {format} from 'date-fns/format'

import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {ServerDate} from '$utils/date'

import type {CommonMonthDate} from '$constants/api-infos'
import type {Dispatch, SetStateAction, PropsWithChildren} from 'react'

interface CardListMonthType {
    selectedMonth: CommonMonthDate
    setSelectedMonth: Dispatch<SetStateAction<CommonMonthDate>>
}

const Context = createContext<CardListMonthType | undefined>(undefined)

export const CardListMonthProvider = ({children}: PropsWithChildren) => {
    const router = useRouter()
    const {month: monthQuery} = router.query

    const [selectedMonth, setSelectedMonth] = useState<CommonMonthDate>(
        router.pathname === INTERNAL_ROUTES.CARD_APPROVAL && typeof monthQuery === 'string'
            ? monthQuery
            : format(ServerDate(), 'yyyy-MM'),
    )

    const value = useMemo(() => ({selectedMonth, setSelectedMonth}), [selectedMonth])
    return <Context.Provider value={value}>{children}</Context.Provider>
}

const useCardListMonth = () => {
    const context = useContext(Context)

    if (context === undefined) {
        throw new Error('useCardListMonth must be within CardListMonthProvider')
    }

    return context
}

export default useCardListMonth
